import {
  FETCH_COUNTRY,
  FETCH_INTEREST,
  MAKE_ACTION,
  SET_CARDS,
  SET_ASSETS,
  SET_HIDE_LOCK_ROOM,
  SET_LOADING,
} from './commonTypes'

const initialState = {
  countries: false,
  interests: false,
  assets: [],
  cards: [],
  hideLockConfirm: false,
  loading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case FETCH_COUNTRY:
      return {
        ...state,
        countries: action.payload,
      }
    case FETCH_INTEREST:
      return {
        ...state,
        interests: action.payload,
      }
    case MAKE_ACTION:
      return {
        ...state,
      }
    case SET_CARDS:
      return {
        ...state,
        cards: action.payload,
      }
    case SET_ASSETS:
      return {
        ...state,
        assets: action.payload,
      }
    case SET_HIDE_LOCK_ROOM:
      return {
        ...state,
        hideLockConfirm: action.payload,
      }
    default:
      return state
  }
}
